import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { setClassNames } from '@ddc/classnames-js';
import { usePrefs, useLabels } from 'wsm-common-data';
import { ResultsContext } from '../contexts';
import { g } from '../global-constants';

const SearchLinks = ({ type, data, isEmbedded }) => {
	const labels = useLabels();
	const { handleLinkClick } = useContext(ResultsContext);
	const { display } = usePrefs();
	const isPanelMode = display === g.NAVIGATION_DRAWER;

	const classNames = [
		isPanelMode ? 'ddc-font-size-small' : 'ddc-font-size-base',
		'font-weight-bold',
		'mt-0'
	];
	const searchLinksWrapperClassNames = ['px-4'];
	const resultLinkClassName = setClassNames([
		'd-flex',
		'align-items-center',
		'list-group-item',
		'ddc-font-size-base',
		isPanelMode && 'sts-panel-list-item'
	]);

	if (type === 'no-results') {
		classNames.push('sr-only');
	}

	if (type === 'inventory') {
		const isEverySuggestionCountOne = data.every(
			(item) => item.count === 1
		);
		if (isEverySuggestionCountOne) {
			return null;
		}
	}

	const ariaLabel =
		type === 'inventory'
			? labels.get('INVENTORY_SEARCH_RESULTS')
			: labels.get('PAGE_SEARCH_RESULTS');

	const iconClass =
		type === 'inventory'
			? 'ddc-icon-single-vehicle'
			: 'ddc-icon-arrow-circle-right';

	if (data?.length > 0) {
		let keyCount = 0;
		const maxLinks = isEmbedded && type !== 'inventory' ? 25 : 5;
		const headingLabel =
			type === 'inventory'
				? `${labels.get('VIEW_SIMILAR_VEHICLES')}`
				: `${labels.get('WEBSITE_RESOURCES')}`;
		return (
			<div
				data-testid={`sts-${type}-search-links`}
				role="region"
				aria-labelledby={`${type}-search-links-heading`}
				className={setClassNames(searchLinksWrapperClassNames)}
			>
				<span
					id={`${type}-search-links-heading`}
					className={setClassNames(classNames)}
				>
					{headingLabel}
				</span>
				<ul className={setClassNames(['list-group', 'mb-3', 'mt-3'])}>
					{data.slice(0, maxLinks).map((item) => {
						if (
							(!item.title || !item.path) &&
							type === 'no-results'
						) {
							return null;
						}
						keyCount += 1;
						const handleClick = () => {
							const elementCTA = item.title || '';
							let linkType = '';
							let addRecentSearches = true;
							if (type === 'inventory') {
								linkType = 'inventoryLink';
							} else if (type === 'page') {
								linkType = 'pageLink';
							} else if (type === 'no-results') {
								linkType = 'noResultsLink';
								addRecentSearches = false;
							}
							handleLinkClick(
								linkType,
								elementCTA,
								'',
								addRecentSearches
							);
						};
						return (
							<li
								key={keyCount}
								className={setClassNames(['line-height-reset'])}
							>
								<a
									className={resultLinkClassName}
									href={item.path}
									// eslint-disable-next-line max-len
									aria-label={`${labels.get('VISIT')} ${
										item.title
									} ${ariaLabel}`}
									onClick={handleClick}
								>
									<i
										className={`ddc-icon ${
											iconClass || item?.icon
										} ddc-icon-size-large mr-3`}
										aria-hidden="true"
									/>
									<span>{item.title}</span>
								</a>
							</li>
						);
					})}
				</ul>
			</div>
		);
	}
	return null;
};

SearchLinks.propTypes = {
	type: PropTypes.oneOf(['inventory', 'page', 'no-results']).isRequired,
	data: PropTypes.arrayOf(PropTypes.shape({})),
	isEmbedded: PropTypes.bool
};

export default SearchLinks;
